// this page created by akash-ak
import { useState, useEffect } from "react";
import Tabs from "../../../../Components/Tabs";
import GetIcon from "../../../../utils/Icon";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import { useGetPurchaseOrderListMutation, useUploadFileMutation,
   useCreateGateEntryMutation, useGetVehicleListMutation, useUpdateGateEntryMutation,
    useSubmitGateEntryMutation } from '../../../../store/api/gateEntryApiNew'
import { useGetVendorListMutation } from "../../../../store/api/purchaseorderapi";
import Table from "./Table";
import { Link, useNavigate } from 'react-router-dom'
import Attachment from "../../../../utils/Attachment";

const PurchaseForm = () => {
  const [submit, setsubmit] = useState(false);
  const [gateentry, setgateentry] = useState();
  const [po_status, setpo_status] = useState('');
  const [getitem_list_data] = useGetPurchaseOrderListMutation();
  const [uploadFile] = useUploadFileMutation();
  const [vendor_list, setvendor_list] = useState([]);
  const [vehicle_list, setvehicle_list] = useState([]);
  const [selected_item_data, setselected_item_data] = useState([]);
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const nvg = useNavigate()
  const requiredFields = {
    tab1: ['select_transaction_type', 'vendor_name', 'builty_no', 'asn_no'],
    tab2: ['invoice_no', 'invoice_image', 'invoice_date', 'total_no_boxes', 'eway_bill', 'invoice_value', 'total_invoice_qty'],
    tab3: [
      'vehicle_no', 'vehicle_arrival_date',
      'vehicle_arrival_time',
      'select_vehicle',
      'transport_method',
      'driver_name',
      'transporter',
      'driver_mobile_no',
      'sh_weight',
      'vehicle_condition',
      'vehicle_image',
      ]
  };

  const [fieldErrors, setFieldErrors] = useState({
    tab1: {},
    tab2: {},
    tab3: {},
  });

  console.log(fieldErrors,"fieldErrors");
  
  const [tabOneFormData, setTabOneFormData] = useState({
    naming_series: '',
    select_transaction_type: '',
    builty_no: '',
    asn_no: '',
    vendor_name: '',
  });

  const [tabTwoFormData, setTabTwoFormData] = useState({
    invoice_no: '',
    invoice_image: null,
    invoice_date: '',
    total_no_boxes: '',
    invoice_value: '',
    total_invoice_qty: '',
    eway_bill: '',
  });

  const [tabThreeFormData, setTabThreeFormData] = useState({
    vehicle_no: '',
    vehicle_arrival_date: '',
    vehicle_arrival_time: '',
    select_vehicle: '',
    transport_method: '',
    driver_name: '',
    transporter: '',
    driver_mobile_no: '',
    sh_weight: '',
    vehicle_condition: '',
    vehicle_image: null
  });

  useEffect(() => {
    if (selected_item_data.length > 0) {
      const totalBoxes = selected_item_data.reduce((sum, item) => {
        return sum + parseInt(item.quantity || 0);
      }, 0);

      setTabTwoFormData((prev) => ({
        ...prev,
        total_no_boxes: totalBoxes,
      }));
    }
  }, [selected_item_data]);

  const [getvendor_list] = useGetVendorListMutation();
  const getVendorAndWarehouse = async () => {
    const venderApiData = await getvendor_list()
    setvendor_list(venderApiData.data.result);
  }

  const [getVehicleList] = useGetVehicleListMutation();
  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const response = await getVehicleList({ doctype: 'Vehicle' }).unwrap();
        const values = response?.message?.values || [];
        const formattedList = values.map(([name]) => ({ name }));
        setvehicle_list(formattedList);
      } catch (err) {
        console.error('Error fetching vehicles:', err);
      }
    };
    fetchVehicles();
  }, [getVehicleList]);

  useEffect(() => {
    getVendorAndWarehouse()
  }, [])

  const validateForm = () => {
    const newErrors = {
      tab1: {},
      tab2: {},
      tab3: {},

    };

    let isValid = true;

    requiredFields.tab1.forEach(field => {
      if (!tabOneFormData[field]) {
        newErrors.tab1[field] = true;
        isValid = false;
      }
    });

    requiredFields.tab2.forEach(field => {
      if (!tabTwoFormData[field]) {
        newErrors.tab2[field] = true;
        isValid = false;
      }
    });

    requiredFields.tab3.forEach(field => {
      if (!tabThreeFormData[field]) {
        newErrors.tab3[field] = true;
        isValid = false;
      }
    });

    setFieldErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (fieldName, value) => {
    setFieldErrors(prev => ({
      ...prev,
      tab1: {
        ...prev.tab1,
        [fieldName]: false
      }
    }));
    setTabOneFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const handleTabTwoInputChange = async (key, value) => {
    setFieldErrors(prev => ({
      ...prev,
      tab2: {
        ...prev.tab2,
        [key]: false
      }
    }));

    if (key === "invoice_image") {
      const fileUrl = await handleFileUpload(value, uploadFile);
      if (fileUrl) {
        setTabTwoFormData(prev => ({ ...prev, [key]: fileUrl }));
      }
    } else {
      setTabTwoFormData(prev => ({ ...prev, [key]: value }));
    }
  };

  const handleTabThreeInputChange = async (key, value) => {
    setFieldErrors(prev => ({
      ...prev,
      tab3: {
        ...prev.tab3,
        [key]: false
      }
    }));

    if (key === "vehicle_image") {
      const fileUrl = await handleFileUpload(value, uploadFile);
      if (fileUrl) {
        setTabThreeFormData(prev => ({ ...prev, [key]: fileUrl }));
      }
    } else {
      setTabThreeFormData(prev => ({ ...prev, [key]: value }));
    }
  };

  const handleFileUpload = async (file, uploadFileMutation) => {
    const formData = new FormData();
    formData.append('file', file[0]);
    try {
      const res = await uploadFileMutation(formData);
      const fileUrl = res?.data?.message?.file_url;
      return fileUrl;
    } catch (error) {
      console.error("File upload failed:", error);
      return null;
    }
  };

  const preparePayload = () => {
    const payload = {
      doctype: "Gate Entry",
      naming_series: '',
      select_transaction_type: tabOneFormData.select_transaction_type,
      invoice_no: tabTwoFormData.invoice_no,
      builty_no: tabOneFormData.builty_no,
      invoice_date: tabTwoFormData.invoice_date,
      invoice_value: tabTwoFormData.invoice_value,
      total_invoice_qty: tabTwoFormData.total_invoice_qty,
      eway_bill: tabTwoFormData.eway_bill,
      invoice_image: tabTwoFormData.invoice_image,
      vehicle_no: tabThreeFormData.vehicle_no,
      vehicle_image: tabThreeFormData.vehicle_image,
      vehicle_arrival_date: tabThreeFormData.vehicle_arrival_date,
      vehicle_arrival_time: tabThreeFormData.vehicle_arrival_time,
      select_vehicle: tabThreeFormData.select_vehicle,
      transport_method: tabThreeFormData.transport_method,
      driver_name: tabThreeFormData.driver_name,
      transporter: tabThreeFormData.transporter,
      driver_mobile_no: tabThreeFormData.driver_mobile_no,
      sh_weight: tabThreeFormData.sh_weight,
      vehicle_remarks: tabThreeFormData.sh_vehicle_conditionweight,
      total_no_boxes: tabTwoFormData.total_no_boxes,
      vendor_name: tabOneFormData.vendor_name,
      table_phxi: selected_item_data.map(item => ({
        purchase_order: item.item_code,
        box: item.quantity,
      })),
    };

    if (gateentry) {
      payload.name = gateentry;
    }

    return payload;
  };

  const [createGateEntry] = useCreateGateEntryMutation();

  const validatePayload = (payload) => {
		const errors = {
			tab1: {},
			tab2: {},
			tab3: {},
		};
		let isValid = true;

		// Validate Tab 2 fields
		// invoice_value must be a float
		if (
			isNaN((payload.invoice_value))
		) {
			errors.tab2.invoice_value = "Invoice value must be a valid number.";
			isValid = false;
		}
		// total_invoice_qty must be a float
		if (
			isNaN((payload.total_invoice_qty))
		) {
			errors.tab2.total_invoice_qty =
				"Total invoice quantity must be a valid number.";
			isValid = false;
		}
	
		// Regex for Indian vehicle number and other fields
		const driverNameRegex = /^[a-zA-Z\s]+$/;
		const mobileNumberRegex = /^\d{10}$/;

		// Validate Tab 3 fields
		if (!payload.vehicle_no) {
			errors.tab3.vehicle_no = "Vehicle number is required.";
			isValid = false;
		}

		// driver_name must be alphabetic
		if (!payload.driver_name) {
			errors.tab3.driver_name = "Driver name is required.";
			isValid = false;
		} else if (!driverNameRegex.test(payload.driver_name)) {
			errors.tab3.driver_name =
				"Driver name can only contain alphabetic characters and spaces.";
			isValid = false;
		}

		// driver_mobile_no must be exactly 10 digits
		if (!payload.driver_mobile_no) {
			errors.tab3.driver_mobile_no = "Driver mobile number is required.";
			isValid = false;
		} else if (!mobileNumberRegex.test(payload.driver_mobile_no)) {
			errors.tab3.driver_mobile_no = "Mobile number must be exactly 10 digits.";
			isValid = false;
		}

		// sh_weight must be a float
		if (isNaN(parseFloat(payload.sh_weight)) || payload.sh_weight === "") {
			errors.tab3.sh_weight = "Vehicle weight must be a valid number.";
			isValid = false;
		}

		return { isValid, errors };
  };
  
  const saveData = async () => {
    if (!validateForm()) {
      setError('Please fill all required fields');
      setptype('Error');
      setShowError(true);
      return;
    }

    const payload = preparePayload();
    console.log("Payload TAB2",payload)
    
    // 2. Run the validation
    const { isValid, errors: validationErrors } = validatePayload(payload);

    if (!isValid) {
      // 3. If validation fails, handle the errors
      setFieldErrors(validationErrors); // This sets the detailed errors for per-field display

      // Create a user-friendly error message for the pop-up
      let message = 'Please correct the following errors before saving:';

      // To make the pop-up message useful, we can concatenate the first few errors
      const allErrorMessages = Object.values(validationErrors)
        .flatMap(tabErrors => Object.values(tabErrors))
        .filter(msg => msg); // Filter out any empty strings

      if (allErrorMessages.length > 0) {
        // Concatenate the first two errors for a concise pop-up message
        message += `\n- ${allErrorMessages[0]}`;
        if (allErrorMessages.length > 1) {
          message += `\n- ${allErrorMessages[1]}`;
        }
      } else {
        // Fallback message if for some reason we can't find specific errors
        message = 'Validation failed. Please check the form for errors.';
      }

      // Set the pop-up states
      setError(message);
      setShowError(true);

      return; // Stop the save process
  }

    // 4. If validation passes, hide any pop-ups and proceed with saving
    setFieldErrors({ tab1: {}, tab2: {}, tab3: {} }); // Clear previous errors
    setError('');
    setShowError(false);

    // ... proceed with your API call to save the data
    console.log("Payload is valid. Proceeding to save.");

    try {
      const response = await createGateEntry(payload).unwrap();
      const gateEntryName = response?.message?.data?.name || '';
      setTabOneFormData(prev => ({
        ...prev,
        naming_series: gateEntryName,
      }));
      setgateentry(gateEntryName)
      setError('Gate Entry Created');
      setptype('Success');
      setShowError(true);
    } catch (err) {
      console.error('Error creating gate entry:', err);
      setError('Error creating gate entry', err);
      setptype('Error');
      setShowError(true);
    }
  };

  const [updateGateEntry] = useUpdateGateEntryMutation();

  const handleUpdate = async () => {
    if (!validateForm()) {
      setError('Please fill all required fields');
      setptype('Error');
      setShowError(true);
      return;
    }

    const payload = preparePayload();
    try {
      const response = await updateGateEntry(payload).unwrap();
      setError('Gate Entry Updated');
      setptype('Success');
      setShowError(true);
    } catch (error) {
      console.error('Update failed:', error);
      setError('Error updating gate entry', error);
      setptype('Error');
      setShowError(true);
    }
  };

  const [submitGateEntry] = useSubmitGateEntryMutation();

  const handleSubmit = async () => {
    if (!validateForm()) {
      setError('Please fill all required fields');
      setptype('Error');
      setShowError(true);
      return;
    }

    try {
      const response = await submitGateEntry({ gate_entry_name: gateentry }).unwrap();
      setError('Gate Entry Submitted');
      setptype('Success');
      setShowError(true);
      setsubmit(true)
      setpo_status('submitted')
      setTimeout(() => {nvg("inbound/gate-entry/gate-entry-list");}, 2000);
    } catch (error) {
      console.error('Submission failed:', error);
      setError('Error submitting gate entry', error);
      setptype('Error');
      setShowError(true);
    }
  };

  return (
    <>
      <Tabs />
      <div className="d-flex justify-content-between px-2" style={{ background: "#fcfdfe" }}>
        <div className="d-flex align-items-center customizewidth">

          <p className="m-0 breadcrumb-item">Inbound</p>
          <p className="m-0 "> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
          <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/inbound/gate-entry/gate-entry-list')}>Gate Entry List</p>
          <p className="m-0 ">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>


          <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79", fontSize: '' }}>
            New Gate Entry
            <button className="rounded-pill newdesign123">
              New
            </button>
          </a>

        </div>
        <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }}>
          <p style={{ backgroundColor: '#fff', textDecoration: 'none', display: "none" }} className="custom-btn-00989blue m-0">
            + Create Purchase Receipt
          </p>
          {!submit && (
            <>
              {!gateentry && (
                <p
                  style={{ textDecoration: "none", display: "flex" }}
                  className="custom-btn-00989 m-0"
                  onClick={saveData}
                >
                  <GetIcon iconName="LuFilePlus2" size={12} /> &nbsp;
                  Save
                </p>
              )}

              {gateentry && (
                <>
                  <p
                    style={{ textDecoration: "none", display: "flex" }}
                    className="custom-btn-00989 m-0"
                    onClick={handleUpdate}
                  >
                    <GetIcon iconName="LuFilePlus2" size={12} /> &nbsp;
                    Update
                  </p>

                  <p
                    style={{ textDecoration: "none", display: "flex" }}
                    className="custom-btn-00989 m-0"
                    onClick={handleSubmit}
                  >
                    <GetIcon iconName="LuFilePlus2" size={12} /> &nbsp;
                    Submit
                  </p>
                </>
              )}
            </>
          )}

        </div>
      </div>
      <div className="d-flex justify-content-between px-2" style={{ background: "#fcfdfe" }}>

      </div>
      <div className="d-flex justify-content-end" >
                  {gateentry && <Attachment doctype="Gate Entry"  docname={gateentry}  /> }
      </div>

      <div className={gateentry ? "py-2" : "mt-2 py-2"} style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", minHeight: "860px", maxHeight: "1600px" }}>
        <div className="row d-flex justify-content-between">
          <div className="col-12" >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab1
                vendor={{ vendor_list: vendor_list, Error: fieldErrors.vendor }}
                onInputChange={handleInputChange}
                tabOneFormData={tabOneFormData}
                errors={fieldErrors.tab1}
              />
              <Tab2
                tabTwoFormData={tabTwoFormData}
                onInputChange={handleTabTwoInputChange}
                errors={fieldErrors.tab2}
              />
              <Tab3
                vendor_list={vendor_list}
                vehicle_list={vehicle_list}
                tabThreeFormData={tabThreeFormData}
                onInputChange={handleTabThreeInputChange}
                errors={fieldErrors.tab3}
              />
              <Table
                setselected_item_data={setselected_item_data}
                list_data={getitem_list_data}
                po_status={po_status}


              />
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default PurchaseForm;